import { tns } from 'tiny-slider/src/tiny-slider';
import whenDomReady from 'when-dom-ready';

function initialise() {
  const carousels = Array.from(document.querySelectorAll('.js-ds-mobile-carousel'));

  carousels.forEach(initialiseCarousel);
}

/**
 * Initialise carousel.
 * @param {HTMLElement} carousel
 */
function initialiseCarousel(carousel) {
  const breakpoint = parseInt(carousel.getAttribute('data-disable-breakpoint'), 10);

  tns({
    container: carousel,
    items: 1,
    loop: true,
    nav: true,
    navPosition: 'bottom',
    controls: false,
    mouseDrag: true,
    disable: false,
    responsive: {
      [breakpoint]: {
        disable: true,
      },
    },
  });
}

whenDomReady().then(initialise);
